// extracted by mini-css-extract-plugin
export default {"info":"pro_info__KVpuU","text":"pro_text__vQyIs","button":"pro_button__F3VQs","but1":"pro_but1__5BALr","but2":"pro_but2__h1bPJ"};